window.addEventListener('load', function() {
    document.querySelectorAll('.order-value-booster-block').forEach( function(widget) {
      let id = widget.getAttribute('id');
      //console.log("ID:", id);
      waitForElement(`#essential_product_slider_${id}`, 5000)
      .then(function(el) {
        if(!window.Glide) return;
        el.querySelectorAll('.glide__slide--clone').forEach( function(clone) {
          clone.remove();
        });

        let slider = new Glide(`#essential_product_slider_${id}`, {
          type: 'carousel',
          gap: 30,
          peek: 0,
          focusAt: 'center',
          autoplay: 5000,
          breakpoints: {
              4000: { perView: 1 },
              768: { perView: 1 },
              480: {  perView: 1 },
              320: { perView: 1 }
          }
        });

        slider.destroy();

        let s = document.querySelectorAll(".essential_product_slider_glide__arrow");
        s.forEach((e) => {
            e.addEventListener("click", () => {
                slider.go(e.dataset.glideDir);
            });
        });
        let p = new ResizeObserver( () => {
            slider.update()
        });
        p.observe(document.getElementById(`essential_product_slider_${id}`));
        slider.mount();
        // console.log("startAt:", slider.settings.startAt);
        // console.log("focusAt:", slider.settings.focusAt);
        // console.log("SliderType:", slider.type);
        // console.log("perView:", slider.settings.perView);
        // console.log("SliderWidth:", slider.settings.slideWidth);

        //setTimeout(() => {
          let ctas = document.querySelectorAll(`free_shipping_card_product_cta_${id}`);
          ctas.forEach((cta) => {
            cta.addEventListener('click', window.location.reload());
            // cta.addEventListener('click', (e) => {
            //   alert("HERE");
            //   // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            //   //   bubbles: true
            //   // }));
            //   //e.preventDefault();
            //   window.location.reload();
            // });
          });
        //}, 3000);
      })
      .catch(function(err) {
        console.warn(err);
      });
    });

    function waitForElement(selector , timeout = 10000) {
      return new Promise(function(resolve, reject) {
        const interval = 1000; // ms
        const start = Date.now();

        const timer = setInterval(function() {
          let el = document.querySelector(selector);
          if (el) {
            clearInterval(timer);
            resolve(el);
          } else if (Date.now() - start > timeout) {
            clearInterval(timer);
            reject(new Error('Timed out waiting for ' + selector));
          }
        }, interval);
      });
    }
  });